import en from './strings.en';
import { Profile } from 'consts/consts';

const ru = {
    realTrucker: 'РП',
    analyticsTrucks: 'Выставлено ТС',
    actualTrucks: 'ТС на сайте',
    profile: {
        [Profile.default]: 'Default',
        [Profile.trucker]: 'Пер',
        [Profile.owner_trucker]: 'ГВ-Пер',
        [Profile.exp_trucker]: 'Экс-Пер',
        [Profile.exp]: 'Экс',
        [Profile.dispatcher]: 'Дисп',
        [Profile.owner]: 'ГВ',
        [Profile.insurance]: 'Страх',
        [Profile.jur]: 'Юр',
        [Profile.autoService]: 'Сервис',
        [Profile.it]: 'IT',
    },
    clear: 'Очистить',
    fillSaved: 'Заполнить сохраненным',
    save: 'Сохранить в БД',
};

export default { ru, en: { ...ru, ...en} };
